export default {
  state: {
    guideList: []
  },
  mutations: {
    setPersonalGuildList (state, guideList) {
      state.guideList = guideList
    }
  },
  actions: {
    handlePersonalGuildList ({commit}, guideList) {
      commit('setPersonalGuildList', guideList)
    },
  }
}
